"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var alignItemValuesMap = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    baseline: 'baseline',
    stretch: 'stretch',
};
exports.default = (function (_a) {
    var alignItems = _a.alignItems;
    return (alignItems in alignItemValuesMap ? "align-items: " + alignItemValuesMap[alignItems] + ";" : '');
});
